import { render, staticRenderFns } from "./topLeft1.vue?vue&type=template&id=8ba8c888&"
import script from "./topLeft1.vue?vue&type=script&lang=js&"
export * from "./topLeft1.vue?vue&type=script&lang=js&"
import style0 from "./topLeft1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports